import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import PageTemplate from "../ui/page_template";
import {
    initializationZajavls,
    addZajavl,
    setContestDialogOpenZajavls,
    saveAndSendZajavl,
    removeZajavl,
    cancelZajavl,
    getHistoryZajavl,
    removeContestZajavl,
} from '@componentDP/js_react/redux/actions/zajavls';
import Tooltip from '@material-ui/core/Tooltip';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Help from '@material-ui/icons/Help';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Contests from "./contests";
import LoadingZajavls from "./../skeletons/loading_zajavls";
import Chip from '@material-ui/core/Chip';
import {configStatusesTranslateMap} from "../../config/statuses";
import RequirementsDocuments from "./requirements_documents";
import TemplatesDocuments from "./templates_documents";
import NeedHostel from "./need_hostel";
import ZajavlFiles from "./zajavl_files";
import Contest from "./contest";
import ZajavlConfirmDialog from './zajavl_confirm_dialog';
import ZajavlHistoryDialog from './zajavl_history_dialog';
import {cloneDeep} from 'lodash';
import ErrorText from '../simple/ErrorText';
import Exams from '../pages/exams/Exams';
import {withTranslation} from "react-i18next";

class Zajavls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numExpandedPanel: -2,
            isOpenConfirmDialog: false,
            uuidConfirm: '',
            zajavlActionConfirm: '',
            isOpenHistoryDialog: false,
        };
        this.addZajavl = this.addZajavl.bind(this);
        this.handleSaveAndSend = this.handleSaveAndSend.bind(this);
        this.handleOpenConfirmDialog = this.handleOpenConfirmDialog.bind(this);
        this.handleCloseConfirmDialog = this.handleCloseConfirmDialog.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChangePanel = this.handleChangePanel.bind(this);
        this.handleOpenHistoryDialog = this.handleOpenHistoryDialog.bind(this);
        this.handleCloseHistoryDialog = this.handleCloseHistoryDialog.bind(this);
        this.handleRemoveContest = this.handleRemoveContest.bind(this);
        const {initializationZajavls} = this.props;
        initializationZajavls();
    }

    addZajavl = () => {
        const {addZajavl} = this.props;
        addZajavl();
    };
    handleSaveAndSend = () => {
        const state = this.state;
        const {saveAndSendZajavl, t} = this.props;
        saveAndSendZajavl(state.uuidConfirm, this.successSaveCallbackForFiles, t);
        this.setState({...state, isOpenConfirmDialog: false, uuidConfirm: ''});
    };
    handleOpenConfirmDialog = (uuid, action) => {
        const state = this.state;
        this.setState({...state, isOpenConfirmDialog: true, uuidConfirm: uuid, zajavlActionConfirm: action});
    };
    handleCloseConfirmDialog = () => {
        const state = this.state;
        this.setState({...state, isOpenConfirmDialog: false, uuidConfirm: ''});
    };
    handleRemove = () => {
        const {removeZajavl, t} = this.props;
        const state = this.state;
        removeZajavl(state.uuidConfirm, t);
        this.setState({...state, isOpenConfirmDialog: false, uuidConfirm: ''})
    };
    handleCancel = () => {
        const state = this.state;
        const {cancelZajavl, t} = this.props;
        cancelZajavl(state.uuidConfirm, t);
        this.setState({...state, isOpenConfirmDialog: false, uuidConfirm: ''});
    };
    handleChangePanel = (numPanel) => {
        const state = this.state;
        this.setState({...state, numExpandedPanel: numPanel === state.numExpandedPanel ? -1 : numPanel});
    };
    handleOpenHistoryDialog = (zajavlUuid) => {
        const {state} = this;
        const {getHistoryZajavl, t} = this.props;
        getHistoryZajavl(zajavlUuid, t);
        const newState = {...state, isOpenHistoryDialog: true};
        this.setState(newState);
    };
    handleCloseHistoryDialog = () => {
        const {state} = this;
        this.setState({...state, isOpenHistoryDialog: false});
    };
    handleRemoveContest = () => {
        const state = this.state;
        const {removeContestZajavl, t} = this.props;
        removeContestZajavl(state.uuidConfirm, t);
        this.setState({...state, isOpenConfirmDialog: false, uuidConfirm: ''});
    };

    render() {
        const {classes, zajavls, loadingZajavls, allowedOnlineZajavls, profileBasic, i18n, t} = this.props;
        const currentLang = i18n.language;
        const {
            numExpandedPanel,
            isOpenConfirmDialog,
            uuidConfirm,
            zajavlActionConfirm,
            isOpenHistoryDialog,
        } = this.state;
        const {
            addZajavl,
            handleSaveAndSend,
            handleOpenConfirmDialog,
            handleCloseConfirmDialog,
            handleRemove,
            handleCancel,
            handleChangePanel,
            handleOpenHistoryDialog,
            handleCloseHistoryDialog,
            handleRemoveContest,
        } = this;
        return (
            <PageTemplate title={t('zajavls')}>
                {Number(profileBasic.diploma_id) > 0
                    ? loadingZajavls
                        ? <LoadingZajavls/>
                        : allowedOnlineZajavls
                            ? (<Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Exams/>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6" align={"left"}>
                                        {t('list_of_applications')}
                                    </Typography>
                                </Grid>
                                {zajavls.map((zajavl, numZajavl) => {
                                    return (
                                        <Grid item xs={12} key={zajavl.uuid}>
                                            <Accordion
                                                expanded={numExpandedPanel === numZajavl}
                                                onChange={() => {
                                                    handleChangePanel(numZajavl)
                                                }} className={classes.panel}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon/>}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <div className={classes.columnTitle}>
                                                        <Typography variant="h6">
                                                            {zajavl.create_datetime
                                                                ? `${t('application_dated')} ${zajavl.create_datetime}`
                                                                : t('new_application')}
                                                        </Typography>
                                                        {zajavl.dp_zajavl_campaign_name && currentLang === 'ru' ? (
                                                            <Typography variant="body1">
                                                                {zajavl.dp_zajavl_campaign_name}
                                                            </Typography>
                                                        ) : null}

                                                        {zajavl.applicant_unique_code
                                                            ? <Typography variant="body1">
                                                                <Tooltip title={<span
                                                                    className={classes.helperTooltipTextSize}>{t('applicants_ranking_watch_info')}</span>}>
                                                                    <Help className={classes.helperTooltipIconSize}/>
                                                                </Tooltip> {t('applicant_unique_code')}
                                                                : <b>{zajavl.applicant_unique_code}</b>
                                                            </Typography>
                                                            : null}
                                                    </div>

                                                    <div className={`${classes.columnControl} ${classes.alignRight}`}>
                                                        <Chip
                                                            size="small"
                                                            color="primary"
                                                            label={zajavl.status === undefined
                                                                ? t('not_saved')
                                                                : (configStatusesTranslateMap[zajavl.status]
                                                                    ? t(configStatusesTranslateMap[zajavl.status])
                                                                    : t('unknown_status'))}
                                                        />
                                                        <div>
                                                            <Button
                                                                color="primary"
                                                                size="small"
                                                                disabled={!zajavl.id}
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    handleOpenHistoryDialog(zajavl.uuid)
                                                                }}>
                                                                {t('change_history')}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <Contests zajavl={zajavl}
                                                                      handleOpenConfirmDialog={handleOpenConfirmDialog}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <RequirementsDocuments zajavl={zajavl}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TemplatesDocuments zajavl={zajavl}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <ZajavlFiles zajavl={zajavl}
                                                                         successSaveCallback={(fn) => this.successSaveCallbackForFiles = fn}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <NeedHostel zajavl={zajavl}/>
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.alignRight}>
                                                            {zajavl.is_save_and_send_allowed !== false
                                                                ? <Button
                                                                    className={classes.button}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        handleOpenConfirmDialog(zajavl.uuid, 'send')
                                                                    }}
                                                                >
                                                                    {zajavl.is_save_without_send_allowed === true
                                                                        ? t('save_and_submit')
                                                                        : t('save_changes_and_submit')
                                                                    }
                                                                </Button>
                                                                : null}
                                                            {zajavl.is_delete_allowed !== false
                                                                ? <Button
                                                                    className={classes.button}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        handleOpenConfirmDialog(zajavl.uuid, 'remove')
                                                                    }}
                                                                >
                                                                    {t('delete_application')}
                                                                </Button>
                                                                : null}
                                                            {zajavl.is_cancel_allowed === true
                                                                ? <Button
                                                                    className={classes.button}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        handleOpenConfirmDialog(zajavl.uuid, 'cancel')
                                                                    }}
                                                                >
                                                                    {t('withdraw_application')}
                                                                </Button>
                                                                : null}
                                                        </Grid>
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    );
                                })}
                                <Grid item xs={12}>
                                    <Button variant="outlined" size="small" onClick={addZajavl}
                                            disabled={!allowedOnlineZajavls}>
                                        {t('add_application')}
                                    </Button>
                                </Grid>
                                <ZajavlConfirmDialog
                                    isOpenConfirmDialog={isOpenConfirmDialog}
                                    uuidConfirm={uuidConfirm}
                                    zajavlActionConfirm={zajavlActionConfirm}
                                    handleCloseConfirmDialog={handleCloseConfirmDialog}
                                    handleSaveAndSend={handleSaveAndSend}
                                    handleCancel={handleCancel}
                                    handleRemove={handleRemove}
                                    handleRemoveContest={handleRemoveContest}/>
                                <ZajavlHistoryDialog
                                    isOpenHistoryDialog={isOpenHistoryDialog}
                                    handleCloseHistoryDialog={handleCloseHistoryDialog}/>
                                <Contest/>
                            </Grid>)
                            : <Grid container spacing={2}>
                                <Grid item lg={8}>
                                    <ErrorText
                                        message={t('no_online_applications')}/>
                                </Grid>
                            </Grid>
                    : <Grid container spacing={2}>
                        <Grid item lg={8}>
                            <ErrorText
                                message={t('general_info_must_fill')}/>
                        </Grid>
                    </Grid>
                }
            </PageTemplate>
        );
    }
}

function mapStateToProps(state) {
    return {
        zajavls: cloneDeep(state.zajavls),
        loadingZajavls: cloneDeep(state.loadingZajavls),
        allowedOnlineZajavls: cloneDeep(state.allowedOnlineZajavls),
        profileBasic: cloneDeep(state.profileBasic),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initializationZajavls,
        addZajavl,
        setContestDialogOpenZajavls,
        saveAndSendZajavl,
        removeZajavl,
        cancelZajavl,
        getHistoryZajavl,
        removeContestZajavl,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Zajavls));
